import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#fff8f3] mb-4">About Us</h2>
            <div className="w-24 h-1 bg-blue-500 mx-auto"></div>
          </div>
          
          <div className="bg-gray-800 rounded-2xl p-8 shadow-xl">
            <p className="text-lg text-gray-300 leading-relaxed">
              <span className="text-blue-400 font-bold">GxTi</span> is a specialized Information Technology Consulting and Capacity Building Firm with deep competencies in Information Security, 
              Information Assurance, Project Management and Knowledge Capital Development, training, Risk assessment etc. We are 
              positioned to help your organization operate based on industry best practices.
            </p>
            
            <div className="mt-8 grid md:grid-cols-2 gap-8">
              <div className="bg-gray-900 p-6 rounded-xl shadow-lg border border-gray-700">
                <h3 className="text-xl font-semibold text-[#fff8f3] mb-3">Our Mission</h3>
                <p className="text-gray-400">
                  To provide cost-effective security solutions and help organizations manage Governance, Risk Management, and Compliance related to IT operations.
                </p>
              </div>
              
              <div className="bg-gray-900 p-6 rounded-xl shadow-lg border border-gray-700">
                <h3 className="text-xl font-semibold text-[#fff8f3] mb-3">Standards Compliance</h3>
                <p className="text-gray-400">
                  We provide solutions that help organizations address regulations and standards such as PCI DSS, ISO27001, ISO22301, ISO20000, SOC, and ISO9001.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;